module.exports = __webpack_public_path__ + "img/couples-062.19041d09.jpg";